import React, {
 useContext, useRef, useState
} from 'react';
import {
  Dialog,
  DialogContent,
} from 'shared/components/ui/dialog';
import {
 Context
} from 'shared/context/GlobalState';
import {
 channelService
} from 'shared/api';
import {
 ScrollArea
} from 'shared/components/ui/scroll-area';
import AppearanceAndLauncher from './WebchatConfig/AppearanceAndLauncher';
import HomeScreen from './WebchatConfig/HomeScreen';
import WebChatSetup from './WebChatSetup';
import {
  ChannelData,
  WebChatConfigType,
  RedisChannelUpdate,
  EmailUpdateObject,
} from '../types/builderChannel.types';

interface UpdateWebChannelWrapperProps {
  isOpen: boolean;
  setOpenEmailModal: React.Dispatch<React.SetStateAction<boolean>>;
  channel: EmailUpdateObject;
  setEmailChannel: React.Dispatch<React.SetStateAction<EmailUpdateObject>>;
  type: 'appearance-launcher' | 'home-screen';
}

export default function UpdateWebChannelWrapper({
  isOpen,
  setOpenEmailModal,
  channel,
  setEmailChannel,
  type,
}: UpdateWebChannelWrapperProps) {
  const [loading, setLoading] = useState(false);
  const {
 addNewNotifcation
} = useContext(Context);
  const modalRef = useRef<HTMLDivElement | null>(null);
  const [emailUpdateObject, setEmailUpdateObject] =
    useState<EmailUpdateObject>(channel);

  const handleSave = async (
    webChatConfig: WebChatConfigType,
    closeModal?: boolean
  ): Promise<void> => {
    // Server update schema is strict: send keying fields + mutable fields only.
    // (webChatConfig/origins are retained for the WebChat customization intent.)
    const channelObj1: RedisChannelUpdate = {
      org_id: emailUpdateObject.org_id,
      sub_org_id: emailUpdateObject.sub_org_id,
      channelId: emailUpdateObject._id,
      topic: emailUpdateObject.topic,
      origins: emailUpdateObject.origins,
      webChatConfig,
    };

    try {
      setLoading(true);
      await channelService.updateChannel(channelObj1);

      setEmailChannel({
        ...emailUpdateObject,
        ...channelObj1,
      });
      setEmailUpdateObject({
        ...emailUpdateObject,
        ...channelObj1,
      });

      addNewNotifcation('Channel Updated successfully', 'success');
      if (closeModal) setOpenEmailModal(false);
    } catch {

      addNewNotifcation('Something went wrong', 'danger');
    } finally {
      setLoading(false);
    }
  };

  const getUpdateType = () => {
    switch (type) {
      case 'appearance-launcher':
        return (
            <AppearanceAndLauncher
            handleSave={handleSave}
            loading={loading}
            emailUpdateObject={emailUpdateObject}
          />
        );
      case 'home-screen':
        return (
            <HomeScreen
            handleSave={handleSave}
            loading={loading}
            emailUpdateObject={emailUpdateObject}
            modalRef={modalRef}
          />
        );
      default:
        return null;
    }
  };

  return (
      <Dialog open={isOpen} onOpenChange={setOpenEmailModal}>
          <DialogContent
        className="p-0 sm:max-w-[1200px] h-[90vh]"
        ref={modalRef}
      >
              <ScrollArea className="p-4 relative h-full">{getUpdateType()}</ScrollArea>
          </DialogContent>
      </Dialog>
  );
}

interface WebChannelUpdateDialogProps {
  openEmailModal: boolean;
  setOpenEmailModal: React.Dispatch<React.SetStateAction<boolean>>;
  emailUpdateObject: ChannelData | null;
  setEmailChannels: React.Dispatch<React.SetStateAction<ChannelData[]>>;
  setEmailUpdateObject: React.Dispatch<
    React.SetStateAction<ChannelData | null>
  >;
}

export const WebChannelUpdateDialog: React.FC<
  WebChannelUpdateDialogProps
> = ({
  openEmailModal,
  setOpenEmailModal,
  emailUpdateObject,
  setEmailChannels,
  setEmailUpdateObject,
}) => {
  const {
 addNewNotifcation
} = useContext(Context);

  const handleOnSubmit = async (channelObj: any) => {
    if (!channelObj.org_id || !channelObj.sub_org_id) {
      addNewNotifcation('Invalid channel object', 'danger');
      return;
    }

    // Server update schema is strict: send keying fields + mutable fields only.
    const channelObj1: RedisChannelUpdate = {
      org_id: channelObj.org_id,
      sub_org_id: channelObj.sub_org_id,
      channelId: (channelObj as EmailUpdateObject)._id,
      topic: channelObj.topic,
      origins: channelObj.origins,
      includeConvoHistory: channelObj.includeConvoHistory,
      webChatConfig: channelObj.webChatConfig,
    };

    try {
      await channelService.updateChannel(channelObj1);

      setEmailChannels((prev) =>
        prev.map((item) =>
          (item as EmailUpdateObject)._id ===
          (emailUpdateObject as EmailUpdateObject)?._id
            ? {
 ...channelObj
}
            : item
        )
      );

      if (emailUpdateObject) {
        setEmailUpdateObject({
          ...emailUpdateObject,
          ...channelObj,
        });
      }

      addNewNotifcation('Channel Updated successfully', 'success');
      setOpenEmailModal(false);
    } catch {

      addNewNotifcation('Something went wrong', 'danger');
    }
  };

  if (!emailUpdateObject) return null;

  return (
      <Dialog open={openEmailModal} onOpenChange={setOpenEmailModal}>
          <DialogContent className="p-0 sm:max-w-[860px] max-w-none overflow-y-auto max-h-[95svh] sm:max-h-[90vh]">
              <WebChatSetup
          isUpdate={true}
          newChannelObj={emailUpdateObject as EmailUpdateObject}
          onSubmit={handleOnSubmit}
          setOpenEmailModal={setOpenEmailModal}
        />
          </DialogContent>
      </Dialog>
  );
};
